import { call, put, takeEvery } from 'redux-saga/effects'

import api from '../../utils/api'
import * as apiErrorHelpers from '../../helpers/apiErrorHelpers'
import { renderSuccessNotification, renderErrorNotification } from '../../helpers/apiHelpers'
import * as sessionHelpers from '../../helpers/sessionHelpers'

export function* mappingCreateOrUpdate(action) {
  try {
    yield put({ type: 'SET_LOADING' })
    yield put({ type: 'UNSET_LOADING_ERROR' })

    api.setAuthApi({
      'Authorization': sessionHelpers.getApplicationCookie('authentication_token')
    })

    yield put({ type: 'MAPPING_CREATE_OR_UPDATE_REQUESTED' })

    const request = {
      url: `/ai_invoice_line_matchers/`,
      body: { ai_invoice_line_matchers: action.payload }
    }

    const response = yield call(api.utility.post, api.path(request.url), { body: request.body })

    apiErrorHelpers.catchErrors(response.body)

    yield put({
      type: 'MAPPING_CREATE_OR_UPDATE_SUCCEEDED',
      payload: {
        data: response.body
      }
    })

    yield put(renderSuccessNotification('Successfully created/updated Ai invoice mapping'))

    yield put({ type: 'UNSET_LOADING'})
  }
  catch (errors) {
    // eslint-disable-next-line
    errors = apiErrorHelpers.formatInternalErrors(errors)

    yield put({ type: 'LOADING_FAILED' })
    yield put({ type: 'SET_LOADING_ERROR' })
    yield put({ type: 'UNSET_LOADING' })

    yield put(renderErrorNotification(
      `Error creating/updating Ai invoice mapping: ${apiErrorHelpers.toString(errors)}`
    ))

    apiErrorHelpers.consoleLog(errors)
  }
} // mappingCreateOrUpdate()

export default function* mappingSaga() {
  yield takeEvery('MAPPING_CREATE_OR_UPDATE_SAGA', mappingCreateOrUpdate)
}
